import { render, staticRenderFns } from "./EcaDataTable.vue?vue&type=template&id=99cf5246"
import script from "./EcaDataTable.vue?vue&type=script&lang=js"
export * from "./EcaDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports